<template>
  <div id="app">
    <Home :content="$options.content" />
  </div>
</template>

<script>
import Home from "@/views/Home.vue";
import content from "./thesis.json";

export default {
  content: content,
  components: {
    Home
  },
  mounted: function() {
    let lastTimestamp = window.performance.now();
    let scroll = function(timestamp) {
      const step = (timestamp - lastTimestamp) * 0.1;
      const factor = 0.65; // <-- Diese Zahl verändern, um die Scrollgeschwindigkeit zu verändern.

      window.scrollBy(factor * step, 0);

      lastTimestamp = timestamp;

      window.requestAnimationFrame(scroll);
    };
    window.requestAnimationFrame(scroll);
  }
};
</script>

<style lang="scss">
#app {
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
}

body {
  height: 100vh;
  overflow-x: scroll;
  overflow-y: hidden;
}
</style>
